import React, { useState } from 'react';

const InterviewDoctorCardioA1 = ({ onClose, shareUrl, shareTitle, shareText }) => {
  const [showShareMenu, setShowShareMenu] = useState(false);

  const handleShareClick = (platform) => {
    const url = shareUrl || window.location.href;
    const title = shareTitle || 'Casual, Conversational Interview With a Cardiac Surgeon';
    const text = shareText || 'Check out this interview about heart health.';

    if (platform === 'whatsapp') {
      window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`);
    } else if (platform === 'email') {
      window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text + "\n\n" + url)}`;
    } else if (platform === 'copy') {
      navigator.clipboard?.writeText(url).then(() => {
        alert('Link copied to clipboard!');
      }).catch(() => {
        const textarea = document.createElement('textarea');
        textarea.value = url;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        alert('Link copied to clipboard!');
      });
    }
    setShowShareMenu(false);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.35)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        overflowY: 'auto',
        paddingTop: '20px',
        paddingBottom: '20px',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 10,
          padding: 24,
          minWidth: 320,
          maxWidth: 600,
          boxShadow: '0 2px 16px rgba(0,0,0,0.15)',
          position: 'relative',
          margin: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            background: 'none',
            border: 'none',
            fontSize: 24,
            color: '#1976d2',
            cursor: 'pointer',
            padding: 0,
            width: 36,
            height: 36,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          title="Close"
        >
          ✕
        </button>

        <h1 style={{ color: '#1976d2', fontSize: '1.1rem', marginBottom: 16 }}>
          Casual, Conversational Interview With a Cardiac Surgeon
        </h1>

        <div style={{ fontSize: '0.80rem', lineHeight: '1.4', color: '#333' }}>
          <p>
            <strong>Interviewer:</strong> Dr. Mehta, thank you for being here! Let's jump straight
            in. What are the heart problems you see most often?
          </p>

          <p>
            <strong>Dr. Mehta:</strong> Thanks for having me! The most common issues I deal with
            are blocked arteries, valve problems, heart failure, and irregular heartbeats. Blocked
            arteries—what people call "heart blockages"—are by far the most common and the main
            reason people end up with heart attacks.
          </p>

          <p>
            <strong>Interviewer:</strong> What usually causes these blockages?
          </p>

          <p>
            <strong>Dr. Mehta:</strong> Most of it comes down to lifestyle. Too much processed
            food, lack of exercise, smoking, high stress—it all adds up. Conditions like high
            blood pressure, diabetes, and high cholesterol also speed up the process. Genetics
            matters too, but lifestyle is the bigger piece of the puzzle.
          </p>

          <p>
            <strong>Interviewer:</strong> And what signs should people not ignore?
          </p>

          <p>
            <strong>Dr. Mehta:</strong> Chest discomfort or tightness, shortness of breath,
            tiredness with light activity, and palpitations. Sometimes people feel dizzy or notice
            swelling in their legs. Women often get less typical symptoms—like nausea or jaw
            pain—so they need to be especially aware.
          </p>

          <p>
            <strong>Interviewer:</strong> Lifestyle seems to be the big theme here. What are your
            top tips for keeping the heart healthy?
          </p>

          <p>
            <strong>Dr. Mehta:</strong> I keep it simple:
            <br />• Move your body—even a 30-minute brisk walk daily is huge.
            <br />• Eat real food—more veggies, less junk.
            <br />• Quit smoking, completely.
            <br />• Manage stress—your heart feels it even if you don't.
            <br />• Sleep well, at least 7 hours a night.
            <br />
            Small steps, done consistently, can literally save your life.
          </p>

          <p>
            <strong>Interviewer:</strong> People struggle the most with diet. Any easy changes you
            recommend?
          </p>

          <p>
            <strong>Dr. Mehta:</strong> Absolutely. Swap fried snacks for nuts or fruit, use olive
            oil instead of butter, cut down on sugary drinks, and try to limit red meat. Adding
            fish twice a week is great too. The Mediterranean style of eating is one of the best
            for the heart and very doable.
          </p>

          <p>
            <strong>Interviewer:</strong> Stress is tricky. How does it really affect the heart?
          </p>

          <p>
            <strong>Dr. Mehta:</strong> Stress makes your body release hormones that raise blood
            pressure and heart rate. Over time, this puts wear and tear on the arteries. Even five
            minutes of deep breathing, meditation, or a short walk can calm your system. People
            underestimate how powerful stress reduction is.
          </p>

          <p>
            <strong>Interviewer:</strong> What about regular check-ups? How often should people get
            screened?
          </p>

          <p>
            <strong>Dr. Mehta:</strong> Once a year for blood pressure. Cholesterol every 4–6
            years, sooner if you have risk factors. If someone has diabetes, weight issues, or a
            strong family history, they should check more often. And if you're having symptoms,
            don't wait—get evaluated right away.
          </p>

          <p>
            <strong>Interviewer:</strong> Speaking of family history, can someone beat their
            genetics?
          </p>

          <p>
            <strong>Dr. Mehta:</strong> Yes—100%. You can't change your genes, but you can change
            how they express themselves. People with strong family history must be extra careful
            with lifestyle, diet, and stress. Think of it like this: genetics load the gun, but
            lifestyle pulls the trigger.
          </p>

          <p>
            <strong>Interviewer:</strong> That's a powerful way to put it. Before we wrap up,
            what's one message you want younger people to hear?
          </p>

          <p>
            <strong>Dr. Mehta:</strong> Don't wait for your 40s or 50s to think about your heart.
            I'm seeing heart attacks in people under 35 now. The choices you make in your 20s and
            30s determine how your heart behaves later. Start early—you'll thank yourself.
          </p>
        </div>
        <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid #eee', fontSize: '0.85rem', color: '#999' }}>
          <p style={{ margin: 0 }}>Dr. Mehtha is a leading Cardio surgeon with 22 years of experience in open heart surgery and regenerative medicine.</p>
        </div>

        <div style={{ marginTop: 24, paddingTop: 16, borderTop: '1px solid #ddd', display: 'flex', gap: '1rem', alignItems: 'center', position: 'relative' }}>
          <div style={{ position: 'relative' }}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowShareMenu(!showShareMenu);
              }}
              style={{
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                padding: '8px 12px',
                borderRadius: 4,
                cursor: 'pointer',
                fontSize: '0.75rem',
                minWidth: 'auto',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
              title="Share"
            >
              <span style={{ lineHeight: 1 }}>Share</span>
              <span style={{ fontSize: '0.8rem', opacity: 0.9 }}>▾</span>
            </button>

            {showShareMenu && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '100%',
                  left: 0,
                  background: '#fff',
                  border: '1px solid #ddd',
                  borderRadius: 4,
                  boxShadow: '0 -2px 8px rgba(0,0,0,0.15)',
                  marginBottom: 8,
                  minWidth: 140,
                  zIndex: 10,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => handleShareClick('whatsapp')}
                  style={{
                    display: 'block',
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    padding: '8px 12px',
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontSize: '0.75rem',
                    borderBottom: '1px solid #eee',
                    color: '#25D366',
                    fontWeight: 500,
                  }}
                >
                  WhatsApp
                </button>
                <button
                  onClick={() => handleShareClick('email')}
                  style={{
                    display: 'block',
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    padding: '8px 12px',
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontSize: '0.75rem',
                    borderBottom: '1px solid #eee',
                    color: '#333',
                  }}
                >
                  Email
                </button>
                <button
                  onClick={() => handleShareClick('copy')}
                  style={{
                    display: 'block',
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    padding: '8px 12px',
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontSize: '0.75rem',
                    color: '#333',
                  }}
                >
                  Copy Link
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewDoctorCardioA1;
